import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  BadgeCheck,
  CalendarCheck,
  CheckCircle2,
  IndianRupee,
  Scale,
  TrendingUp,
} from "lucide-react";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("ITR Analysis Report", 40, yPos);
    yPos += 40;

    // Taxpayer Profile
    doc.setFontSize(14);
    doc.text("Taxpayer Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Name: ${data.assesseeDetails?.name || data.taxpayerDetails?.name || data.name || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.assesseeDetails?.pan || data.taxpayerDetails?.pan || data.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`DOB: ${data.assesseeDetails?.dateOfBirth || data.taxpayerDetails?.dob || data.dateOfBirth || 'N/A'}`, 40, yPos);
    doc.text(`Filing Status: ${data.assesseeDetails?.filingStatus || data.itrDetails?.filingStatus || data.filingStatus || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Assessment Year: ${data.assesseeDetails?.assessmentYear || data.itrDetails?.assessmentYear || data.assessmentYear || 'N/A'}`, 40, yPos);
    doc.text(`ITR Type: ${data.assesseeDetails?.itrType || data.itrDetails?.formType || data.itrType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Filing Date: ${data.assesseeDetails?.filingDate || data.itrDetails?.filingDate || data.filingDate || 'N/A'}`, 40, yPos);
    doc.text(`Status: ${data.assesseeDetails?.status || data.taxpayerDetails?.status || data.status || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Income Breakdown
    doc.setFontSize(14);
    doc.text("Income Head-Wise Breakdown", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Salary Income: Rs ${data.incomeBreakdown?.salaryIncome || 'N/A'}`, 40, yPos);
    doc.text(`Business Income: Rs ${data.incomeBreakdown?.businessIncome || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Other Sources: Rs ${data.incomeBreakdown?.otherIncome || 'N/A'}`, 40, yPos);
    doc.text(`Capital Gains: Rs ${data.incomeBreakdown?.capitalGains || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`House Property: Rs ${data.incomeBreakdown?.housePropertyIncome || 'N/A'}`, 40, yPos);
    doc.text(`Agricultural: Rs ${data.incomeBreakdown?.agriculturalIncome || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Gross Total Income: Rs ${data.incomeDetails?.grossIncome || 'N/A'}`, 40, yPos);
    doc.text(`Taxable Income: Rs ${data.incomeDetails?.taxableIncome || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Tax Computation
    doc.setFontSize(14);
    doc.text("Tax Computation Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Total Tax Liability: Rs ${data.incomeDetails?.taxPaid || 'N/A'}`, 40, yPos);
    doc.text(`TDS Credit: Rs ${data.taxComputation?.tdsCredit || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Refund Due: Rs ${data.incomeDetails?.refundDue || 'N/A'}`, 40, yPos);
    doc.text(`Effective Tax Rate: ${data.taxComputation?.effectiveTaxRate || 'N/A'}%`, 300, yPos);
    yPos += 15;
    doc.text(`Total Deductions: Rs ${data.deductions?.totalDeductions || 'N/A'}`, 40, yPos);
    doc.text(`Advance Tax: Rs ${data.taxComputation?.advanceTaxPaid || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Deductions
    doc.setFontSize(14);
    doc.text("Deduction Details", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Section 80C: Rs ${data.deductions?.section80C || 'N/A'}`, 40, yPos);
    doc.text(`Section 80D: Rs ${data.deductions?.section80D || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`HRA Exemption: Rs ${data.deductions?.hraExemption || 'N/A'}`, 40, yPos);
    doc.text(`Section 24(b): Rs ${data.deductions?.section24b || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Standard Deduction: Rs ${data.deductions?.standardDeduction || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Cash Flow Indicators
    doc.setFontSize(14);
    doc.text("Cash Flow Indicators", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Income Stability: ${data.cashFlowIndicators?.incomeStability || 'N/A'}`, 40, yPos);
    doc.text(`YOY Growth: ${data.cashFlowIndicators?.yoyGrowth || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Savings Ratio: ${data.cashFlowIndicators?.savingsRatio || 'N/A'}`, 40, yPos);
    doc.text(`Net Tax Paid: ${data.cashFlowIndicators?.netTaxPaid || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Compliance & Filing
    doc.setFontSize(14);
    doc.text("Compliance & Filing Behaviour", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Filed on Time: ${data.complianceDetails?.filedOnTime || 'N/A'}`, 40, yPos);
    doc.text(`Form Consistency: ${data.complianceDetails?.formConsistency || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Tax Audit Applicable: ${data.complianceDetails?.taxAuditApplicable || 'N/A'}`, 40, yPos);
    doc.text(`Proper Deductions: ${data.complianceDetails?.properDeductions || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Tax Matches 26AS: ${data.complianceDetails?.taxMatches26AS || 'N/A'}`, 40, yPos);
    doc.text(`Document Authenticity: ${data.complianceDetails?.documentAuthenticity || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Verdict
    doc.setFontSize(14);
    doc.text("Final Credit Analyst Verdict", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Income Level: ${data.finalVerdict?.incomeLevel || 'N/A'}`, 40, yPos);
    doc.text(`Tax Compliance: ${data.finalVerdict?.taxCompliance || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Filing Behaviour: ${data.finalVerdict?.filingBehaviour || 'N/A'}`, 40, yPos);
    doc.text(`Eligibility Support: ${data.finalVerdict?.eligibilitySupport || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Loan Eligibility: ${data.finalVerdict?.loanEligibility || 'N/A'}`, 40, yPos);
    doc.text(`Max Eligible Loan: Rs ${data.finalVerdict?.maxEligibleLoan || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "ITR analysis completed based on available tax return data.",
      "Tax compliance and filing behavior have been assessed.",
      "Income verification completed for lending eligibility."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("itr-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const ITRAnalysisReport = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-6 text-sm space-y-6 min-h-screen ">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal ITR Analyser (ITR-1 to ITR-7)</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Taxpayer Profile */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📄 Taxpayer Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Name</strong>
            <span className="text-white">
              {getValue("assesseeDetails.name") ||
                getValue("taxpayerDetails.name") ||
                getValue("name")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN Number</strong>
            <span className="text-white">
              {getValue("assesseeDetails.pan") ||
                getValue("taxpayerDetails.pan") ||
                getValue("pan")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Date of Birth</strong>
            <span className="text-white">
              {getValue("assesseeDetails.dateOfBirth") ||
                getValue("taxpayerDetails.dob") ||
                getValue("dateOfBirth")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Filing Status</strong>
            <span className="text-white">
              {getValue("assesseeDetails.filingStatus") ||
                getValue("itrDetails.filingStatus") ||
                getValue("filingStatus")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Assessment Year</strong>
            <span className="text-white">
              {getValue("assesseeDetails.assessmentYear") ||
                getValue("itrDetails.assessmentYear") ||
                getValue("assessmentYear")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">ITR Form Type</strong>
            <span className="text-white">
              {getValue("assesseeDetails.itrType") ||
                getValue("itrDetails.formType") ||
                getValue("itrType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Filing Date</strong>
            <span className="text-white">
              {getValue("assesseeDetails.filingDate") ||
                getValue("itrDetails.filingDate") ||
                getValue("filingDate")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Status</strong>
            <span className="text-white">
              {getValue("assesseeDetails.status") ||
                getValue("taxpayerDetails.status") ||
                getValue("status")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Residential Status</strong>
            <span className="text-white">
              {getValue("assesseeDetails.residentialStatus") ||
                getValue("taxpayerDetails.residentialStatus") ||
                getValue("residentialStatus")}
            </span>
          </div>
        </div>
      </div>

      {/* Income Breakdown */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <IndianRupee size={18} /> Income Head-Wise Breakdown
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Salary Income</strong>
              <span className="text-yellow-400">
                ₹{data.incomeBreakdown?.salaryIncome?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Other Sources</strong>
              <span className="text-white">
                ₹{data.incomeBreakdown?.otherIncome?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">House Property Income</strong>
              <span className="text-white">
                ₹
                {data.incomeBreakdown?.housePropertyIncome?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Agricultural Income</strong>
              <span className="text-white">
                ₹
                {data.incomeBreakdown?.agriculturalIncome?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Business Income</strong>
              <span className="text-white">
                ₹
                {data.incomeBreakdown?.businessIncome?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Capital Gains</strong>
              <span className="text-white">
                ₹{data.incomeBreakdown?.capitalGains?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Gross Total Income</strong>
              <span className="text-green-400">
                ₹{data.incomeDetails?.grossIncome?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Total Taxable Income</strong>
              <span className="text-blue-400">
                ₹{data.incomeDetails?.taxableIncome?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Tax Computation */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Scale size={18} /> Tax Computation Summary
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          <div>
            <strong>Total Tax Liability:</strong>{" "}
            <span className="text-red-400">
              ₹{data.incomeDetails?.taxPaid?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
          <div>
            <strong>TDS Credit Claimed:</strong>{" "}
            <span className="text-green-400">
              ₹{data.taxComputation?.tdsCredit?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
          <div>
            <strong>Refund Due:</strong> ₹
            {data.incomeDetails?.refundDue?.toLocaleString("en-IN") || "N/A"}
          </div>
          <div>
            <strong>Effective Tax Rate:</strong>{" "}
            {data.taxComputation?.effectiveTaxRate || "N/A"}%
          </div>
          <div>
            <strong>Total Deductions:</strong> ₹
            {data.deductions?.totalDeductions?.toLocaleString("en-IN") || "N/A"}
          </div>
          <div>
            <strong>Advance Tax Paid:</strong> ₹
            {data.taxComputation?.advanceTaxPaid?.toLocaleString("en-IN") || "N/A"}
          </div>
        </div>
      </div>

      {/* Deductions */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <IndianRupee size={18} /> Deduction Details
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Section 80C (PF, Insurance)
              </strong>
              <span className="text-white">
                ₹{data.deductions?.section80C?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Section 80D (Health Insurance)
              </strong>
              <span className="text-white">
                ₹{data.deductions?.section80D?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">HRA Exemption</strong>
              <span className="text-white">
                ₹{data.deductions?.hraExemption?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Section 24(b)</strong>
              <span className="text-white">
                ₹{data.deductions?.section24b?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Standard Deduction</strong>
              <span className="text-white">
                ₹{data.deductions?.standardDeduction?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Total Deductions</strong>
              <span className="text-green-400">
                ₹{data.deductions?.totalDeductions?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Yearly Comparison */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <TrendingUp size={18} /> Multiple Year Comparison
        </div>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full mt-3 text-sm min-w-[500px] border-collapse">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th className="text-left">Year</th>
                <th className="text-left">Total Income</th>
                <th className="text-left">Tax Paid</th>
                <th className="text-left">Remarks</th>
              </tr>
            </thead>
            <tbody className="text-white">
              {(
                data.yearlyComparison || [
                  {
                    year: "AY 2024-25",
                    totalIncome: 1250000,
                    taxPaid: 185000,
                    remarks: "Filed on time",
                  },
                  {
                    year: "AY 2023-24",
                    totalIncome: 1180000,
                    taxPaid: 165000,
                    remarks: "Filed on time",
                  },
                  {
                    year: "AY 2022-23",
                    totalIncome: 1090000,
                    taxPaid: 145000,
                    remarks: "Filed on time",
                  },
                ]
              ).map((record, i) => (
                <tr key={i}>
                  <td>{record.year}</td>
                  <td>₹{record.totalIncome?.toLocaleString("en-IN")}</td>
                  <td>₹{record.taxPaid?.toLocaleString("en-IN")}</td>
                  <td className="text-green-400">{record.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Cash Flow Indicators */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CalendarCheck size={18} /> Cash Flow Indicators
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Income Stability</strong>
              <span className="text-green-400">
                {data.cashFlowIndicators?.incomeStability || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">YOY Growth</strong>
              <span className="text-green-400">
                {data.cashFlowIndicators?.yoyGrowth || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Savings to Income Ratio
              </strong>
              <span className="text-white">
                {data.cashFlowIndicators?.savingsRatio || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Net Tax Paid</strong>
              <span className="text-white">
                {data.cashFlowIndicators?.netTaxPaid || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Compliance & Filing */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BadgeCheck size={18} /> Compliance & Filing Behaviour
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Return Filed on Time</strong>
              <span className="text-white">
                {data.complianceDetails?.filedOnTime || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">ITR Form Consistency</strong>
              <span className="text-white">
                {data.complianceDetails?.formConsistency || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Tax Audit Applicable</strong>
              <span className="text-white">
                {data.complianceDetails?.taxAuditApplicable || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Proper Deductions Claimed
              </strong>
              <span className="text-white">
                {data.complianceDetails?.properDeductions || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Tax Paid Matches 26AS</strong>
              <span className="text-white">
                {data.complianceDetails?.taxMatches26AS || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Document Authenticity</strong>
              <span className="text-green-400">
                {data.complianceDetails?.documentAuthenticity || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Final Verdict */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CheckCircle2 size={18} /> Final Credit Analyst Verdict
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Income Level</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.incomeLevel || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Tax Compliance</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.taxCompliance || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Filing Behaviour</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.filingBehaviour || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Eligibility Support</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.eligibilitySupport || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Loan Eligibility</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.loanEligibility || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Max Eligible Loan</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹{data.finalVerdict?.maxEligibleLoan?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
        <h3 className="font-semibold text-green-500 mb-2">📝 Final Comments</h3>
        <ul className="list-disc pl-5 space-y-1">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              ITR analysis completed based on available tax return data.
            </li>,
            <li key="default2">
              Tax compliance and filing behavior have been assessed.
            </li>,
            <li key="default3">
              Income verification completed for lending eligibility.
            </li>,
            <li key="default4">
              Recommendation based on tax compliance and income stability.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default ITRAnalysisReport;
